import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { alpha } from '@mui/material/styles';
const faqs = [
  { q: "📄 ¿Qué documentos necesito para importar a Venezuela?", a: "Necesitas factura comercial, DUA, BL/AWB y certificado de origen, entre otros." },
  { q: "💲 ¿Cómo se calculan aranceles e impuestos?", a: "Se basa en el valor CIF más el arancel ad‑valorem; luego se aplican IVA y tasas." },
  { q: "⏱️ ¿Cuánto tarda el despacho de aduana?", a: "Entre 24 y 72 h si la documentación está en orden, pero puede variar." },
  { q: "🤝 ¿Qué hace exactamente una agencia aduanera?", a: "Representa al importador ante la aduana, gestiona documentos y asegura el cumplimiento legal." },
  { q: "🚢 ¿Cuál es la diferencia entre FOB y CIF (Incoterms)?", a: "FOB transfiere riesgo en puerto de origen; CIF incluye seguro y flete hasta destino." },
];


    const FAQ = () => {
  const pearl = '#FFFFFF';
  const pearlGlass = alpha(pearl, 0.72);
  return (
  <Box id="faq" sx={{ py: 8 }}>
    <Container>
      <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          sx={{
            mb: 4,
                   display: 'block',
            px: 2,
              pt: 0.5,
            pb: 1.5,
            bgcolor: pearlGlass,
            color: 'text.primary',
            backdropFilter: 'blur(6px)',
            borderRadius: 1,
          }}
        >
        Preguntas Frecuentes
      </Typography>
      {faqs.map((faq) => (
        <Accordion key={faq.q} sx={{ mb: 1, bgcolor: 'background.paper', borderRadius: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">{faq.q}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">{faq.a}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  </Box>
  );
};

export default FAQ;